var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var _a;
import { useSetState } from 'ahooks';
import { createGlobalStore } from 'hox';
import { useState } from 'react';
export var useAiReportStore = (_a = __read(createGlobalStore(function () {
    var _a = __read(useSetState({
        token: '',
        stepToken: '',
        disabledScore: true,
        showAiDimension: true,
        canEditAiDimension: true,
        scoreRankIntervals: [],
        operableButtons: [],
        reportRank: { rank: 0, total: 0 },
        customInterviewDimRankMap: {},
    }), 2), state = _a[0], updateState = _a[1];
    var _b = __read(useState(), 2), reportResult = _b[0], updateReportResult = _b[1];
    return __assign(__assign({}, state), { reportResult: reportResult, updateState: updateState, updateReportResult: updateReportResult });
}), 2), _a[0]), getAiReportStore = _a[1];
